import { FETCH_REWARD_POINTS } from '../actionTypes/rewardPoints';
import { getRewardPoints } from '../apis/rewardPoints';
import { FUNLIDAY_STATUS, RESPONSE_CONTENT_CODE } from '../constants/response';

export const getRewardPointsBalance = () => async dispatch => {
  dispatch({ type: FETCH_REWARD_POINTS.LOADING });
  try {
    const response = await getRewardPoints();
    const code = response?.data?.code;
    const isStatusOK = response.status === +FUNLIDAY_STATUS.SUCCESS;
    const isSuccess =
      code === RESPONSE_CONTENT_CODE.SUCCESS ||
      code === RESPONSE_CONTENT_CODE.NO_RESULTS;
    if (isStatusOK && isSuccess) {
      const { data, data_next, extras } = response.data;
      dispatch({
        type: FETCH_REWARD_POINTS.SUCCESS,
        payload: {
          data,
          dataNext: data_next,
          extras
        }
      });
    } else {
      dispatch({ type: FETCH_REWARD_POINTS.FAIL });
      return 'fail';
    }
  } catch (error) {
    dispatch({ type: FETCH_REWARD_POINTS.FAIL });
    return 'fail';
  }

  return 'success';
};
